/**
 * src/lib/programs.js — đọc/ghi chương trình trên Firestore (collection `programs`).
 *
 * Trang /chuong-trinh hiện ngay danh sách đóng gói lúc build, rồi đọc Firestore
 * để lấy thay đổi mới nhất. Người quản trị sửa xong là người dùng thấy ngay,
 * không cần deploy lại.
 */
import { useEffect, useState } from 'react';
import { CO_CAU_HINH, layDb } from './firebase.js';
import { PROGRAMS, PROGRAMS_GOC } from '../data/programs.js';
import { chuanHoaChuongTrinh, gopChuongTrinh, KHOA_CHUONG_TRINH } from './programModel.js';

const COL = 'programs';

async function fs() {
  const db = await layDb();
  if (!db) throw new Error('Website chưa cấu hình Firebase.');
  return { db, sdk: await import('firebase/firestore/lite') };
}

/** Bản ghi công khai: đã xuất bản hoặc đã ẩn (để ẩn đúng bản trong code). */
export async function docChuongTrinhCongKhai() {
  const { db, sdk } = await fs();
  const q = sdk.query(sdk.collection(db, COL), sdk.where('status', 'in', ['PUBLISHED', 'ARCHIVED']));
  const snap = await sdk.getDocs(q);
  return snap.docs.map((d) => chuanHoaChuongTrinh({ ...d.data(), slug: d.id }));
}

/** Danh sách cho trang /chuong-trinh: bản build trước, Firestore sau. */
export function useChuongTrinh() {
  const [list, setList] = useState(PROGRAMS);
  useEffect(() => {
    if (!CO_CAU_HINH) return undefined;
    let live = true;
    docChuongTrinhCongKhai()
      .then((remote) => { if (live) setList(gopChuongTrinh(PROGRAMS_GOC, remote)); })
      .catch(() => { /* giữ bản build */ });
    return () => { live = false; };
  }, []);
  return list;
}

/* ---------------- Quản trị ---------------- */

export async function docTatCaChuongTrinh() {
  const { db, sdk } = await fs();
  const snap = await sdk.getDocs(sdk.collection(db, COL));
  return snap.docs.map((d) => chuanHoaChuongTrinh({ ...d.data(), slug: d.id }));
}

export async function luuChuongTrinh(raw, status, email = '') {
  const { db, sdk } = await fs();
  const p = chuanHoaChuongTrinh({ ...raw, status });
  if (!p.slug) throw new Error('Thiếu đường dẫn (slug).');
  // programId giữ nguyên với chương trình có sẵn trong code (có thể khác slug),
  // để bản trên Firestore thay đúng bản trong code khi gộp.
  const data = { ...p, programId: p.programId || p.slug, status, updatedAt: new Date().toISOString(), updatedBy: email };
  for (const k of Object.keys(data)) if (!KHOA_CHUONG_TRINH.includes(k)) delete data[k];
  await sdk.setDoc(sdk.doc(db, COL, p.slug), data);
  return data;
}

export async function xoaChuongTrinh(slug) {
  const { db, sdk } = await fs();
  await sdk.deleteDoc(sdk.doc(db, COL, slug));
}

/**
 * Chép chương trình có sẵn trong code lên Firestore để sửa được trên trang
 * quản trị. KHÔNG ghi đè bản đã có trên Firestore.
 */
export async function nhapTuCode(daCo, email = '') {
  const thieu = PROGRAMS_GOC.filter((p) => !daCo.includes(p.slug));
  for (const p of thieu) await luuChuongTrinh(p, 'PUBLISHED', email);
  return thieu.length;
}
